'use client';
import { useRef } from 'react';
import { Provider } from 'react-redux';
import { store, AppStore } from '@/store/store';

export const ReduxProvider = ({ children }: { children: React.ReactNode }) => {
  const storeRef = useRef<AppStore | null>(null);
  if (!storeRef.current) {
    storeRef.current = store(); // 工厂模式
  }
  return <Provider store={storeRef.current}>{children}</Provider>;
};